import { Component, Input } from '@angular/core';
import { FormHeaderComponent } from 'tuain-ng-forms-lib';
import { IconDictionaryService } from 'src/app/services/icon-dictionary.service';

const ELLIPSIS_ICON = 'ELLIPSIS';

@Component({
  selector: 'app-form-header',
  templateUrl: './app-form-header.component.html',
  styleUrls: ['./app-form-header.component.less'],
})
export class AppFormHeaderComponent extends FormHeaderComponent {
  @Input() icon: any;
  @Input() showTitle: boolean = true;
  ellipsisIcon: string;

  constructor(public _iconDictionary: IconDictionaryService) {
    super();
    this.ellipsisIcon = this._iconDictionary.mapIcon(ELLIPSIS_ICON);
  }
}
